module.exports = __webpack_public_path__ + "img/listNameB.d43791b2.png";